/** 定数 */
export class Constant {
	/** ホームページ */
	static readonly HOMEPAGE = "https://salon-de-gloria.com";
}